import { render, staticRenderFns } from "./CollapsiblePanel.vue?vue&type=template&id=49a810c7&scoped=true&"
import script from "./CollapsiblePanel.vue?vue&type=script&lang=js&"
export * from "./CollapsiblePanel.vue?vue&type=script&lang=js&"
import style0 from "./CollapsiblePanel.vue?vue&type=style&index=0&id=49a810c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a810c7",
  null
  
)

export default component.exports